/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import '@ciscospark/internal-plugin-wdm';

import {registerInternalPlugin} from '@ciscospark/spark-core';
import {has} from 'lodash';

import Presence from './presence';
import config from './config';

registerInternalPlugin('presence', Presence, {
  payloadTransformer: {
    predicates: [
      {
        name: 'normalizeSingleStatusResponse',
        direction: 'inbound',
        test(ctx, response) {
          // POST to /apheleia/api/v1/events
          return Promise.resolve(has(response, 'body.eventType') && has(response, 'body.subject'));
        },
        extract(response) {
          return Promise.resolve(response);
        }
      }
    ],
    transforms: [
      {
        name: 'normalizeSingleStatusResponse',
        direction: 'inbound',
        fn(ctx, response) {
          response.body.status = response.body.eventType;
        }
      }
    ]
  },
  config
});

export {default} from './presence';
